import React, { useState, useEffect } from "react";
import "../css/Footer.css"; // Dedicated styles

import { NavLink } from "react-router-dom";
// Import highly descriptive modern icons from FontAwesome
import {
  FaPhoneAlt,
  FaEnvelope,
  FaInfoCircle,
  FaAddressBook,
  FaAward,
  FaGavel,
  FaFileContract,
  FaLaptopCode,
  FaBookReader,
  FaChartLine,
  FaSchool,
  FaComments,
  FaGift,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedinIn,
  FaArrowUp
} from "react-icons/fa";

// Import your brand assets here
import footerBg from "../../images/Banner8.png";
import brandLogo from "../../images/logo.png";

function Footer() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Monitor scroll position to toggle back-to-top button visibility
  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollTop && window.pageYOffset > 300) {
        setShowScrollTop(true);
      } else if (showScrollTop && window.pageYOffset <= 300) {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, [showScrollTop]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer
      className="main-footer"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      <div className="container">
        <div className="row footer-columns-row">

          {/* Column 1: Brand details & contacts */}
          <div className="col-lg-3 col-md-6 footer-col-item">
            <div className="footer-brand-column">
              <img src={brandLogo} alt="Brand Logo" className="footer-logo mb-3" />
              <p className="footer-description">
                Empowering scalable framework growth with modern design modules and responsive infrastructure architectures built for digital efficiency.
              </p>
              <div className="footer-contacts">
                <p className="contact-item">
                  <FaPhoneAlt className="contact-icon" />
                  <strong>P:</strong>
                  <a href="tel:+917595856611" className="contact-phone-link">
                    + (91) 75958 56611
                  </a>
                </p>

                <p className="contact-item">
                  <FaPhoneAlt className="contact-icon" />
                  <strong>P:</strong>
                  <a href="tel:+916289581169" className="contact-phone-link">
                    + (91) 62895 81169
                  </a>
                </p>
                <p className="contact-item email-highlight">
                  <FaEnvelope className="contact-icon" /> <strong>E:</strong> <a href="mailto:info@crestest.com">info@crestest.com</a>
                </p>
              </div>
            </div>
          </div>

          {/* Column 2: Navigation Links */}
          <div className="col-lg-2 col-md-6 footer-col-item">
            <div className="footer-links-column">
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-list">
                <li>
                  <NavLink to="/about">
                    <FaInfoCircle className="link-icon" /> About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/unique-features">
                    <FaAward className="link-icon" /> Unique Features
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact">
                    <FaAddressBook className="link-icon" /> Contact Us
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/associates">
                    <FaGift className="link-icon" /> Associates
                  </NavLink>
                </li>
                {/* <li>
                  <a
                    href="https://lms.crestest.com/page-login"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaGift className="link-icon" /> Login
                  </a>
                </li> */}
              </ul>
            </div>
          </div>

          {/* Column 3: Utility Links */}
          <div className="col-lg-3 col-md-6 footer-col-item">
            <div className="footer-links-column">
              <h4 className="footer-heading">Services</h4>
              <ul className="footer-list">
                <li>
                  <NavLink to="/online-exam">
                    <FaLaptopCode className="link-icon" /> Online Exam
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/e-library">
                    <FaBookReader className="link-icon" /> e-Library
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/performance-scorecard">
                    <FaChartLine className="link-icon" /> Performance Scorecard
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/forum">
                    <FaComments className="link-icon" /> Forum
                  </NavLink>
                </li>
                <li>
                  <a
                    href="https://school.crestest.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaSchool className="link-icon" /> School ERP
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Column 4: Quick Links */}
          <div className="col-lg-2 col-md-6 footer-col-item">
            <div className="footer-links-column">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-list">
                {/* <li>
                  <a
                    href="https://crestestlearning.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaGift className="link-icon" /> Freemium
                  </a>
                </li> */}
                {/* <li>
                  <a
                    href="https://kirnavali.crestestlearning.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaGift className="link-icon" /> Kirnavali
                  </a>
                </li> */}
                <li>
                  <NavLink to="/faq">
                    <FaGift className="link-icon" /> FAQs
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/privacy-policy">
                    <FaFileContract className="link-icon" /> Privacy Policy
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/terms-and-conditions">
                    <FaGavel className="link-icon" /> Terms & Conditions
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>

          {/* Column 5: Social Framework & Updates (Connect) */}
          <div className="col-lg-2 col-md-6 footer-col-item">
            <div className="footer-links-column">
              <h4 className="footer-heading">Connect</h4>
              <ul className="footer-list">
                <ul className="footer-list">
                  <li>
                    <a
                      href="https://www.facebook.com/profile.php?id=100070855191458&mibextid=ZbWKwL"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebookF className="link-icon" /> Facebook
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.instagram.com/crestestlearning?igsh=MTMyaGNyNGhxbzMyOA=="
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="link-icon" /> Instagram
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://x.com/CrestestL?t=HZ0eOHnnFhuaUxE6Ottp0w&s=08"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaTwitter className="link-icon" /> X (Twitter)
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://youtube.com/@crestestlearning7882?si=C3Nc705m7PwsRWaz"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaYoutube className="link-icon" /> YouTube
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.linkedin.com/posts/crestest-learning_activity-7120658377931710464-fR85?utm_source=share&utm_medium=member_android"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedinIn className="link-icon" /> LinkedIn
                    </a>
                  </li>
                </ul>
              </ul>
            </div>
          </div>

        </div>

        {/* Dynamic Horizontal Line Splitter */}
        <hr className="footer-divider" />

        {/* Copyright strip & Circular Back-to-Top Button */}
        <div className="row align-items-center footer-bottom-strip">
          <div className="col-12 text-center position-relative">
            <p className="footer-copyright mb-0">
              &copy; {new Date().getFullYear()} Crestest. All Rights Reserved.
            </p>

            {/* Small Circular Back to Top Floating Button */}
            {/* {showScrollTop && (
              <button
                onClick={scrollToTop}
                className="footer-scroll-top-btn"
                title="Back to Top"
                aria-label="Back to top"
              >
                <FaArrowUp />
              </button>
            )} */}
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;